var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main", staticStyle: { position: "relative" } },
    [
      _vm.existBusinessIntelligenceDashboard
        ? [
            _c("business-intelligence-dashboard", {
              style: _vm.showBusinessIntelligenceDashboard
                ? ""
                : "display: none !important"
            })
          ]
        : _vm._e(),
      _vm.existCargoInsurance
        ? [
            _c("cargo-insurance", {
              style: _vm.showCargoInsurance ? "" : "display: none !important"
            })
          ]
        : _vm._e(),
      _vm.existInsureList
        ? _vm._l(_vm.existInsureList, function(item, index) {
            return _c("to-insure-page", {
              key: index,
              style: _vm.showToInsurePage(item)
                ? ""
                : "display: none !important"
            })
          })
        : _vm._e(),
      _vm.existJmReportList
        ? _vm._l(_vm.existJmReportList, function(item) {
            return _c("jm-report-iframe", {
              key: item.query.key,
              style: _vm.showJmReportPage(item)
                ? ""
                : "display: none !important",
              attrs: { "report-path": item.query.reportPath }
            })
          })
        : _vm._e(),
      [
        _c(
          "keep-alive",
          { attrs: { include: _vm.cachedViews.concat([_vm.homePageView]) } },
          [
            !_vm.showBusinessIntelligenceDashboard &&
            !_vm.showCargoInsurance &&
            _vm.toShowInsurePage &&
            _vm.toShowJmReportRouterView
              ? _c("router-view", { key: _vm.key, ref: "routerView" })
              : _vm._e()
          ],
          1
        )
      ],
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.ieTipVisible,
            "append-to-body": "",
            "show-close": false,
            "custom-class": "ieTip",
            width: "960px"
          }
        },
        [
          _c("p", { staticStyle: { "font-size": "14px" } }, [
            _vm._v(_vm._s(_vm.$t("Message.DearUser")))
          ]),
          _c("p", [_vm._v(_vm._s(_vm.$t("Message.ItSystemInOrderMode")))]),
          _c("p", [_vm._v(_vm._s(_vm.$t("Message.TheShownInTheBelow")))]),
          _c("img", { attrs: { src: _vm.ieTipImg } }),
          _c(
            "p",
            [
              _vm._v(_vm._s(_vm.$t("Message.ToSwitchTutorialsSee"))),
              _c(
                "el-link",
                {
                  staticStyle: { "vertical-align": "top" },
                  attrs: {
                    type: "primary",
                    href: "https://cargoware.s2.udesk.cn/hc/articles/28724",
                    target: "_blank"
                  }
                },
                [_vm._v("https://cargoware.s2.udesk.cn/hc/articles/28724")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.ieTipVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          ref: "expandDiv",
          staticStyle: {
            position: "absolute",
            bottom: "50px",
            right: "14px",
            "z-index": "900",
            width: "350px!important"
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showWoBaoInfo,
                  expression: "showWoBaoInfo"
                }
              ],
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "background-color": "#FFFFFF",
                padding: "10px 10px",
                height: "270px"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    gap: "10px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        gap: "10px"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "75px", height: "60px" },
                        attrs: { src: require("@/assets/icons/wobao.png") }
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                            width: "155px",
                            gap: "5px",
                            "padding-top": "10px",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#E57975",
                                "font-weight": "bold",
                                "font-size": "14px",
                                cursor: "pointer"
                              },
                              on: { click: _vm.clickOpenSysMsg }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SystemMaintenance.TodayUnReadMsg") +
                                    "（" +
                                    (_vm.woBaoInfo.number || 0) +
                                    "）"
                                )
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#555555",
                                "font-weight": "bold",
                                "font-size": "14px",
                                "padding-bottom": "0",
                                overflow: "hidden",
                                "text-overflow": "ellipsis",
                                display: "-webkit-box",
                                "-webkit-line-clamp": "2",
                                "-webkit-box-orient": "vertical"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.woBaoInfo.info.topic || "") +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "flex-end",
                        width: "65px",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-close",
                        staticStyle: { "font-size": "20px" },
                        on: { click: _vm.clickWoBaoInfoClose }
                      }),
                      _c("span", [
                        _vm._v(_vm._s(this.convertNotifyDateToHHmm()) + " ")
                      ])
                    ]
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "320px",
                    height: "200px",
                    position: "relative"
                  }
                },
                [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.woBaoInfo.info.content) }
                  }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.woBaoInfo.info && _vm.woBaoInfo.info.link,
                          expression: "woBaoInfo.info && woBaoInfo.info.link"
                        }
                      ],
                      staticStyle: {
                        float: "right",
                        position: "absolute",
                        bottom: "5px",
                        right: "5px"
                      },
                      attrs: { type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.btnShowDetailHandler(_vm.woBaoInfo.info)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LookDetail")) + " ")]
                  )
                ],
                1
              )
            ]
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showWoBaoIcon,
              expression: "showWoBaoIcon"
            }
          ],
          staticStyle: {
            position: "absolute",
            bottom: "50px",
            right: "14px",
            "z-index": "900",
            display: "flex",
            "flex-direction": "column",
            "align-items": "flex-end",
            "justify-content": "flex-end"
          },
          on: {
            mouseenter: function($event) {
              _vm.showCloseText = true
            },
            mouseleave: function($event) {
              _vm.showCloseText = false
            }
          }
        },
        [
          _vm.showCloseText
            ? _c(
                "span",
                {
                  staticClass: "close-text",
                  on: { click: _vm.clickWoBaoIconCloseText }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DisableOpen")))]
              )
            : _vm._e(),
          _c("img", {
            staticStyle: { "margin-right": "0" },
            attrs: {
              src: require("@/assets/icons/wobao.png"),
              draggable: "false"
            },
            on: { click: _vm.clickWoBaoIcon }
          })
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }